import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import { Encrption } from "../app-modules/encrption";


const getAllDefaultStaffDocumentTemplates = (value) => {
  return ApiHelper.getRequest(API_URLS.GET_STAFF_DOCUMENT_TEMPLATE + Encrption(value?.id));

}
const addStaffDocTemplate = (fields) => {
  const data = {
    templateName: fields.templateName,
    isHtmlFileTypeTemplate: fields.isFileTemplate,
    htmlFileName: fields.htmlFileName,
    isDefault: fields.isDefault,
    regionId: fields.regionName.id,
  };
  return ApiHelper.postRequest(API_URLS.INSERT_UPDATE_STAFF_DOCUMENT_TEMPLATE, data);
};
const assignStaffTemplate = (fields, documentTemplateId, sourceRegionId) => {
  const list = documentTemplateId.map((item) => item?.id)
  const data = {
    templateIds: list,
    clinicId: fields?.clinicName?.id,
    regionId: sourceRegionId?.regionName?.id,
  };
  return ApiHelper.postRequest(API_URLS.ASSIGN_STAFF_TEMPLATE_TO_CLINIC, data);
};
const assignStaffTemplateLabel = (label, documentTemplateId, regionId, checkedTemplates) => {
  let templateIdArray;
  if (documentTemplateId.id) {
    templateIdArray = [documentTemplateId.id];
  } else if (checkedTemplates) {
    templateIdArray = checkedTemplates.map(template => template.id);
  } else {
    templateIdArray = [];
  }
  const data = {
    templateIds: templateIdArray,
    labelId: label?.id,
    regionId: regionId,
  };
  return ApiHelper.postRequest(API_URLS.POST_ASSIGN_LABEL_TO_STAFF_TEMPLATE, data);
};
const updateStaffTemplate = (fields, documentTemplateId, regionId) => {
  const data = {
    id: documentTemplateId,
    templateName: fields?.templateName,
    htmlFileName: fields?.htmlFileName,
    regionId: regionId
  }
  return ApiHelper.postRequest(API_URLS.INSERT_UPDATE_STAFF_DOCUMENT_TEMPLATE, data)
}
const deleteAssignStaffPlanTemplate = (selectedId, regionId, selectedTemplateInfo) => {
  return ApiHelper.deleteRequest(API_URLS.DELETE_ASSIGN_STAFF_PLAN_TEMPLATE + regionId + '&masterClinicId=' + selectedId + '&templateId=' + selectedTemplateInfo?.id);
}
const getAllClinic = (sourceRegionId) => {
  const payload = {
    region: sourceRegionId?.regionName?.id || null,
    isActive: true,
    state: null,
    isRCM: null,
    customerStatusId: null,
  };

  return ApiHelper.postRequest(
    API_URLS.GET_ALL_CLINIC_BY_REGION,
    payload
  );
};

export const staffPlanTemplateService = {
  getAllDefaultStaffDocumentTemplates,
  addStaffDocTemplate,
  assignStaffTemplate,
  assignStaffTemplateLabel,
  updateStaffTemplate,
  deleteAssignStaffPlanTemplate,
  getAllClinic
};
